define('view/module/PromoAlertView',['require','lib/view/LayoutView','view/module/ClientTermsView','lib/view/ModalRegion','view/controller/booking/details/DetailsLicenseView','Config','lib/ExtendClassProperty'],function (require) {

    var LayoutView = require('lib/view/LayoutView');

    var ClientTermsView = require('view/module/ClientTermsView');
    var ModalRegion = require('lib/view/ModalRegion');
    var DetailsLicenseView = require('view/controller/booking/details/DetailsLicenseView');
    var Config = require('Config');

    var extendProperty = require('lib/ExtendClassProperty');

    return ClientTermsView.extend({

        template: '#promo_alert_terms_view',

        ui: extendProperty('ui', {
            'promoLettersCheckbox': '#sb_promotion_letters_flag',
            'simplybookPromoTerms': '#sb_promo_terms_link a',
        }),

        events: extendProperty('events', {
            'change @ui.promoLettersCheckbox': 'onChangeInput',
            'click @ui.simplybookTerms': 'showPromoLetterSimplybookTerms',
            'click @ui.simplybookPromoTerms': 'showPromoLetterUserTerms',
        }),

        modelEvents: {
            'sync': 'render',
            'change': 'render',
        },

        initialize: function () {
            var _this = this;
            ClientTermsView.prototype.initialize.apply(this, arguments);

            this.listenTo(this.model, 'sync', function (){
                //console.log('sync');
                if(_this.model.set('promotion_letters') !== true
                    && _this.model.getTermsAndConditions().isPromoLettersVisible()) {
                    _this.model.set('promotion_letters', null);
                }
            });
        },

        onChangeInput: function (event) {
            var el = $(event.target);
            if(String(el.attr('name')).indexOf('promotion_letters') !== -1){
                this.model.set('promotion_letters', !el.is(':checked'));
            } else {
                this.model.set(el.attr('name'), el.is(':checked'));
            }
        },

        showPromoLetterSimplybookTerms: function (event) {
            event.preventDefault();
            var view = this.showLicenseDialog(this._termsAndConditionsModel, null, 'simplybook_terms_flag');

            this.listenTo(view, 'confirm', _.bind(function () {
                this.model.set('promotion_letters', false);
            }, this));
        },

        showPromoLetterUserTerms: function (event) {
            event.preventDefault();
            var view = this.showLicenseDialog(this._userTermsAndConditionsModel, null, 'user_terms_flag');

            this.listenTo(view, 'confirm', _.bind(function () {
                this.model.set('promotion_letters', false);
            }, this));
        },

        onRender : function() {
        },

        serializeData: function () {
            var company = Config.getInstance().getOption('company_data');

            var result = _.extend({
                'show_simplybook_terms': this.model.getTermsAndConditions().isSimplybookTermsAndConditionsVisible(),
                'show_user_terms': this.model.getTermsAndConditions().isUserTermsAndConditionsVisible(),
                'show_cancellation_policy': this.model.getTermsAndConditions().isCancellationPolicyVisible(),
                'show_promotion_letter': this.model.getTermsAndConditions().isPromoLettersVisible(),
                'errors': this.model.validationError,
                'company': company.name,
                'server_address': Config.getInstance().getOption('server_address'),
                'project': Config.getInstance().getOption('project_name'),
            }, LayoutView.prototype.serializeData.apply(this));

            if(result.show_promotion_letter && !result.show_user_terms && !result.show_simplybook_terms){
                result.show_simplybook_terms = true;
            }
            result.promotion_letters_flag = this.model.get('promotion_letters');

            return result;
        }

    });

});
